export const LoGin = (text) => ({
    type: 'LOGIN',
    text
});
export const LogOut = () => ({
    type: 'LOGOUT',
});
export const Token = (token) => ({
    type: 'TOKEN',
    token
});
export const AddToCart = (item) => ({
    type: 'ADDTOCART',
    item
})
export const IncreaseQuanity = (item) => ({
    type: 'INCREASEQUANTITY',
    item
})
export const DecreaseQuanity = (item) => ({
    type: 'DECREASEQUANTITY',
    item
})
export const RemoveFromCart = (item) => ({
    type: 'REMOVEFROMCART',
    item
})